// This file is automatically generated. Do not edit manually.

import { CustomerOrderProfitabilityHistoryEventDto } from "src/api/generated/erp/sales/customerOrder/profitability/model/customerOrderProfitabilityHistoryEventDto";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderProfitabilityHistoryApi {
	export async function getHistory(args: {
		customerOrderId: number;
	}): Promise<Array<CustomerOrderProfitabilityHistoryEventDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/profitabilityHistory/getHistory",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as Array<CustomerOrderProfitabilityHistoryEventDto>;
	}
}
